
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Toast } from 'vant'
import type { SharePopupParams } from './index.vue'
import { shareImgToWeixin, saveToAlbum } from '@/utils/h5ToApp'

@Component
class PosterPreview extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: '' }) posterUrl!: string
  @Prop({ default: null }) popupParams!: SharePopupParams | null

  compressPosterUrl = ''

  close () {
    this.$emit('close')
    this.compressPosterUrl = ''
  }

  async getCompressPosterUrl () {
    if (!this.posterUrl) {
      Toast('海报图片为空')
      return
    }
    // 已压缩不重复压缩
    if (this.compressPosterUrl) return
    this.compressPosterUrl = await this.compressBase64Image(this.posterUrl)
  }

  /**
  * 压缩 base64 图片，适配微信分享大小限制
  * 策略：限制最大宽度为1280px，质量为0.7，格式为JPEG
  */
  compressBase64Image (base64: string, maxWidth = 1280, quality = 0.7): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image()
      img.onload = () => {
        let { width, height } = img
        if (width > maxWidth) {
          const ratio = maxWidth / width
          width = maxWidth
          height = Math.round(height * ratio)
        }

        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          resolve(base64)
          return
        }
        // 白色背景填充（避免透明变黑）
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, width, height)
        ctx.drawImage(img, 0, 0, width, height)

        resolve(canvas.toDataURL('image/jpeg', quality))
      }
      img.onerror = () => resolve(base64)
      img.src = base64
    })
  }

  onSendFriend () {
    this.shareImgToWeixin('session')
  }

  onShareTimeline () {
    this.shareImgToWeixin('timeline')
  }

  async shareImgToWeixin(scene: 'session' | 'timeline' | 'favorite') {
    await this.getCompressPosterUrl()
    // 传参
    const shareParams: any = {
      imageBase64: this.compressPosterUrl,
      scene
    }

    shareImgToWeixin(shareParams)
  }

  async savePoster() {
    await this.getCompressPosterUrl()
    saveToAlbum(this.compressPosterUrl, () => {
      Toast.success('保存成功')
    })
  }
}

export default PosterPreview
